import i18n from "i18next";
import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {brand} from '../../theme/brand';
import {env} from "../../config/environment";
import {adminConfigurationService} from "../../services/admin-config.service";
import ChatInput from '../../components/chat/ChatInput';
import ChatMessages from '../../components/chat/ChatMessages';
import {useConversation} from '../../contexts/ConversationContext';
import {useSnackbar} from '../../contexts/SnackbarContext';
import {parseError} from '../../errors/http.service';
import {
    CenterContent,
    ChatCard,
    ChatContainer,
    ChatHeader,
    ChatWrapper,
    LogoWrapper,
    TopBarContainer,
} from './Chat.styled';
import CircularProgress from '@mui/material/CircularProgress';
import {Model} from "../../models/admin-config.models";
import {Typography} from "@mui/material";


const Chat = () => {
    const {t} = useTranslation();
    // const navigate = useNavigate();
    // const {showSnackbar} = useSnackbar();

    const {
        state,
        sendMessage,
        retryMessage,
        retryInNewChat,
        stopGeneration,
        activateVariant,
        exportToPdf,
        // setInitialModel,
    } = useConversation();

    const {messages, streamingMessage, isGenerating, answerVariants, isLoading, contextExceeded} = state;

    // const [model, setModel] = useState<Model | null>(null);
    // const [isModelLoading, setIsModelLoading] = useState(false);

    const { clientTheme } = env;
    const chatDescription = `brand.${clientTheme}.description`;
    const hasDescription = i18n.exists(chatDescription);

    // useEffect(() => {
    //     const loadModel = async () => {
    //         setIsModelLoading(true);
    //
    //         try {
    //             const data = await adminConfigurationService.getDefaultModelConfig();
    //             setModel(data);
    //             setInitialModel(data.id);
    //         } catch (e) {
    //             console.error(e);
    //             showSnackbar(parseError(e), 'error');
    //         } finally {
    //             setIsModelLoading(false);
    //         }
    //     };
    //
    //     loadModel();
    // }, []);

    // const handleOpenDataSources = () => {
    //     const chatId = state.conversationId ?? '';
    //
    //     navigate('/data-sources/list', {
    //         state: {
    //             backPath: `/chat/${chatId}`,
    //         }
    //     });
    // };

    return (
        <ChatContainer>
            <ChatWrapper>
                <ChatCard $isEmpty={messages?.length === 0}>
                    <TopBarContainer>
                        <div style={{ flex: 1 }} />

                        {/*<HeaderActions>*/}
                        {/*    /!* [AI-809] [To be possibly uncommented in the future] *!/*/}
                        {/*    /!*<Tooltip title={t('chat.goToDataSources')}>*!/*/}
                        {/*    /!*    <IconButton*!/*/}
                        {/*    /!*        onClick={handleOpenDataSources}*!/*/}
                        {/*    /!*        sx={{color: theme.palette.primary.main}}*!/*/}
                        {/*    /!*    >*!/*/}
                        {/*    /!*        <DataSourceIcon/>*!/*/}
                        {/*    /!*    </IconButton>*!/*/}
                        {/*    /!*</Tooltip>*!/*/}
                        {/*    <Tooltip title={t('chat.downloadConversation')}>*/}
                        {/*        <IconButton*/}
                        {/*            onClick={exportToPdf}*/}
                        {/*            sx={{color: theme.palette.primary.main}}*/}
                        {/*        >*/}
                        {/*            <DocumentDownloadIcon/>*/}
                        {/*        </IconButton>*/}
                        {/*    </Tooltip>*/}
                        {/*</HeaderActions>*/}
                    </TopBarContainer>

                    {isLoading && (
                        <CenterContent>
                            <CircularProgress color="primary" size={48} />
                        </CenterContent>
                    )}

                    {!isLoading && messages?.length === 0 && (
                        <CenterContent>
                            {brand.hasMainLogo && (
                                <LogoWrapper>
                                    <img src={brand.logo} alt="Trusted AI Assistant Logo"/>
                                </LogoWrapper>
                            )}

                            <ChatHeader $isBigSpace={messages?.length === 0}>
                                {t(`brand.${clientTheme}.chatLabel`)}
                            </ChatHeader>

                            {hasDescription && (
                                <Typography variant="body1" component="span" mb={5} color="text.hint">
                                    {t(chatDescription)}
                                </Typography>
                            )}
                        </CenterContent>
                    )}

                    {!isLoading && messages?.length > 0 && (
                        <ChatMessages
                            messages={messages}
                            streamingMessage={streamingMessage}
                            onRetry={retryMessage}
                            onRetryNewChat={retryInNewChat}
                            canRetry={!isGenerating}
                            variants={answerVariants}
                            onActivateVariant={activateVariant}
                            canNavigateVariants={!isGenerating}
                            isGenerating={isGenerating}
                            exportToPdf={exportToPdf}
                        />
                    )}

                    <ChatInput
                        onSendMessage={sendMessage}
                        onStopGeneration={stopGeneration}
                        isGenerating={isGenerating}
                        disabledInput={isLoading || contextExceeded}
                        conversationId={state.conversationId}
                    />
                </ChatCard>
            </ChatWrapper>
        </ChatContainer>
    );
};

export default Chat;
